module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"smartAd":{"errors":{"noImage":"No image."}}},"es":{"smartAd":{"errors":{"noImage":"No hay imagen."}}},"fr":{"smartAd":{"errors":{"noImage":"Aucune image."}}},"pt":{"smartAd":{"errors":{"noImage":"Nenhuma imagem."}}},"de":{"smartAd":{"errors":{"noImage":"Kein Bild."}}},"nl":{"smartAd":{"errors":{"noImage":"Geen beeld."}}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@intlify/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/modules/documents/components/PublicDocumentSmartAd.vue
// module id = Fi3X
// module chunks = 10